export default __webpack_public_path__ + "static/RootSans-3Light-fdf7ac602d14c1a85b1e3f4b6ed646fe.woff";